import { $ABTest, $UserAgent } from '@lemon8/web-app-shared/atom';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';
import { $IsMobileUser } from '../is-mobile-user';

/**
 * 0: control group
 * 1: Video article style align with Gallery
 */
export const $UserPostMasonry: Atom<number> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return 1;
  }
  return _get(parameters, ['seo_web', 'lemon8.user_post_masonry'], 0);
});

export const $HitUserPostMasonry: Atom<boolean> = atom((get) => {
  const config = get($UserPostMasonry);
  const isMobileUser = get($IsMobileUser);
  return isMobileUser && config === 1;
});
